import RedirectList from './List'
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing'

export default {
  list: RedirectList,
  icon: CallMissedOutgoingIcon
}
